import styled from "styled-components";
import Colors from "../../../shared/colors";

export default styled.div`
  position: absolute;
  bottom: 0;
  height: 40px;
  width: 100%;
  background: linear-gradient(
    180deg,
    ${Colors.white} -61.5%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: rotate(-180deg);
  z-index: 0;

  .wrapper-footer {
    padding-left: 20px;
    padding-right: 20px;
    transform: rotate(-180deg);
    padding-bottom: 15px;
    margin-top: 5px;

    .center {
      display: grid;
      justify-content: center;
      margin-top: -55px;
      color: ${Colors.doveGray};
      text-align: center;
      @media screen and (max-width: 1200px) {
        margin-top: 0px;
      }
    }

    .wrapper-footer-loggedin {
      display: flex;
      align-items: center;

      span {
        color: ${Colors.aquaDeep};
        margin-left: 5px;
        margin-right: 5px;
      }
    }

    .center-notLoggedIn {
      margin-top: -20px;
      @media screen and (max-width: 1200px) {
        margin-top: 0px;
      }
    }

    a {
      color: ${Colors.doveGray};
      text-decoration: initial;
    }
    b {
      margin-left: 3px;
    }

    @media (max-width: 768px) {
      padding-bottom: 0;
    }
  }
`;
